import {httpReq} from "@/htttpReq";
import store from "../../store";
import router from "../../../router";

export default {
  namespaced: true,

  state: {
    insertMesh: []
  },

  getters: {
    insert(state) {
      for (let k in state.insertMesh.data) {
        if (k === 'INS') {
          return state.insertMesh.data[k];
        }
      }
    },

    mesh(state) {
      for (let k in state.insertMesh.data) {
        if (k === 'MESH') {
          return state.insertMesh.data[k];
        }
      }
    }
  },

  mutations: {
    updateInsert(state, payload) {
      state.insertMesh = payload;
    }
  },

  actions: {
    getInsertMesh({commit}) {
      store.commit('preloader/preloader', true);
      httpReq.get('/order/order-additional-options',
        {
          params: {
            type: store.getters['createdOrder/createdOrder'].items.type_id,
            style: store.getters['createdOrder/createdOrder'].items.style_id,
            grade: store.getters['createdOrder/createdOrder'].items.grade_id,
          }
        }
      )
        .then(response => {
          commit('updateInsert', response.data);

          if (response.data.skip) {
            let path = store.getters['app/orderBuilderPath']('ins>' + 0 + '/' + 0);
            router.push({path: path});
          }
        })
        .catch(error => {
          store.commit('errorsModal/openModal', error.response.data.errors);
        })
        .finally(() => {
          store.commit('preloader/preloader', false);
        })
    },
  },
};
